import { Stack, Typography } from "@mui/material";

import Logo from "../../../assets/images/omi_logo.svg";

export const OmiLoading: React.FC = () => {
    return (
        <Stack alignItems="center" height="100%" justifyContent="center" spacing={4}>
            <Logo />
            <Typography>Loading Omi...</Typography>
        </Stack>
    );
};
